import { render, staticRenderFns } from "./ConfigInputHabeasData.vue?vue&type=template&id=398bb958&scoped=true"
import script from "./ConfigInputHabeasData.vue?vue&type=script&lang=js"
export * from "./ConfigInputHabeasData.vue?vue&type=script&lang=js"
import style0 from "./ConfigInputHabeasData.vue?vue&type=style&index=0&id=398bb958&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bb958",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398bb958')) {
      api.createRecord('398bb958', component.options)
    } else {
      api.reload('398bb958', component.options)
    }
    module.hot.accept("./ConfigInputHabeasData.vue?vue&type=template&id=398bb958&scoped=true", function () {
      api.rerender('398bb958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/ConfigInputHabeasData.vue"
export default component.exports